import { Box, Heading, Text } from '@chakra-ui/react';
import { CheckedIcon } from '@udacity/chakra-uds-icons';

import { SanityImage } from '~/components/sanity-image';
import { SanityImageType } from '~/features/page-template/models/image';

import { EnterpriseResourcePageContentItem } from '../models/enterprise-report-content';

export function EnterpriseResourceImageBulletedListBlock({
  title,
  image,
  contentList,
}: {
  title: string;
  image: SanityImageType;
  contentList: EnterpriseResourcePageContentItem[];
}) {
  return (
    <Box
      alignItems='center'
      display='flex'
      flexDirection={{ base: 'column-reverse', lg: 'row' }}
      flexWrap={{ base: 'wrap', lg: 'nowrap' }}
      gap={{ base: '40px', md: '80px' }}
    >
      <Box flexBasis={{ base: '100%', lg: '50%' }}>
        <SanityImage image={image} style={{ objectFit: 'contain' }} />
      </Box>

      <Box display='flex' flexBasis={{ base: '100%', lg: '50%' }} flexDirection='column'>
        <Heading as='h2' size='marketing-4xl'>
          {title}
        </Heading>

        {contentList.map((contentItem) => (
          <Box key={contentItem.title} display='flex' marginTop='40px'>
            <CheckedIcon color='blue.500' height='32px' width='32px' />

            <Box>
              <Text fontWeight='600'>{contentItem.title}</Text>
              <Text marginTop='8px'>{contentItem.text}</Text>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
